module.exports = __webpack_public_path__ + "media/Loops 90 Drums.bb5af5de.wav";